// extracted by mini-css-extract-plugin
export default {"container":"TabList-module__container","clipPathContainer":"TabList-module__clipPathContainer"};